"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(s) {
  return s.replace(/[A-Z]/g, function (m) {
    return "_".concat(m[0]);
  }).toUpperCase();
};